// extracted by mini-css-extract-plugin
export var card = "_redotech-redo-customer-portal-app-src-login-login-card";